import Dashboard from "../Pages/Dashboard";
import CompanyList from "../Pages/CompanyManagement/CompanyList";
import CreateCompany from "../Pages/CompanyManagement/CreateCompany";
import Users from "../Pages/MastersManagement/Users";
import Modilds from "../Pages/MastersManagement/Modilds";
import ModuleMaster from "../Pages/MastersManagement/ModuleMaster";
import EmployeeModuleMaster from "../Pages/MastersManagement/EmployeeModuleMaster";
import EmployeeModuleAssign from "../Pages/MastersManagement/EmployeeModuleAssign";
import AssignModule from "../Pages/MastersManagement/AssignModule";
import CompanyUserCreate from "../Pages/MastersManagement/CompanyUserCreate";
import CompanyOnboard from "../Pages/CompanyManagement/CompanyOnboard";
import GeoLocationHistory from "../Pages/AdminManagement/GeoLocationHistory";
import GeneralSettings from "../Pages/AdminManagement/GeneralSettings";
import BiometricRegistration from "../Pages/CompanyManagement/BiometricRegistration";



// routes.js
const routes = [
  ////////////////////// Dashboard Routing ///////////////////////////
  { path: '/', element: <Dashboard /> },

  
  ////////////////////// Master's Routing ///////////////////////////
  { path: '/Users', element: <Users /> },
  { path: '/Modilds', element: <Modilds /> },
  { path: '/CompanyUserCreate', element: <CompanyUserCreate /> },
  { path: '/ModuleMaster', element: <ModuleMaster /> },
  { path: '/EmployeeModuleMaster', element: <EmployeeModuleMaster /> },
  { path: '/EmployeeModuleAssign', element: <EmployeeModuleAssign /> },
  { path: '/AssignModule', element: <AssignModule /> },

  ////////////////////// company's Routing ///////////////////////////
  { path: '/CreateCompany/:company_id', element: <CreateCompany /> },
  { path: '/CompanyOnboard', element: <CompanyOnboard /> },
  { path: '/CompanyList', element: <CompanyList /> }, 
  { path: '/BiometricRegistration', element: <BiometricRegistration /> }, 
  /////////////////////////// Admin Management ///////////////////////
  { path: '/GeoLocationHistory', element: <GeoLocationHistory /> }, 
  { path: '/GeneralSettings', element: <GeneralSettings /> }, 
];

export default routes;